module.exports = __webpack_public_path__ + "img/picto_side_qrcode.1718e3c9.png";